import { nlsWithConditionTabsStrategy } from './nlsWithConditionTabsStrategy';
import { nlsWithoutConditionTabsStrategy } from './nlsWithoutConditionTabsStrategy';
import { standardWithConditionTabsStrategy } from './standardWithConditionTabsStrategy';
import { standardWithoutConditionTabsStrategy } from './standardWithoutConditionTabsStrategy';

/**
 * Selects and executes the appropriate search strategy based on configuration
 *
 * @param {Object} params - Search parameters
 * @param {boolean} params.isNLS - Whether to use Natural Language Search
 * @param {boolean} params.isConditionTabsEnabled - Whether condition tabs are enabled
 * @param {string} params.query - Search query string
 * @param {Object} params.context - Additional context needed by strategies
 * @returns {Promise<Object>} Search results with inventorySearchResponse and pageSearchResponse
 */
export async function executeSearchStrategy({
	isNLS,
	isConditionTabsEnabled,
	query,
	context
}) {
	// Select the appropriate strategy based on configuration
	// Note: Standard == FFSS
	let strategy;

	if (isNLS && isConditionTabsEnabled) {
		strategy = nlsWithConditionTabsStrategy;
	} else if (isNLS && !isConditionTabsEnabled) {
		strategy = nlsWithoutConditionTabsStrategy;
	} else if (!isNLS && isConditionTabsEnabled) {
		strategy = standardWithConditionTabsStrategy;
	} else {
		strategy = standardWithoutConditionTabsStrategy;
	}

	// Execute the selected strategy
	return strategy({
		query,
		...context
	});
}
